/* 🤖 this file was generated by svg-to-ts*/
export const iconTrash: {
  name: 'trash';
  data: string;
} = {
  name: 'trash',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="currentColor" d="M11 14l-7 .052V5h7v9zM7 3h1V2H7v1zm1.134-3A1.87 1.87 0 0110 1.868V3h4a1 1 0 110 2h-1v9.05A1.951 1.951 0 0111.052 16H3.948A1.951 1.951 0 012 14.05V5H1a1 1 0 110-2h4V1.867C5 .837 5.837 0 6.866 0zM6 6a1 1 0 00-1 1v5a1 1 0 102 0V7a1 1 0 00-1-1zm3 0a1 1 0 00-1 1v5a1 1 0 102 0V7a1 1 0 00-1-1z" fill-rule="evenodd"/></svg>`,
};
